// Application constant goes here

export const KYCConstants = {
  helpPhoneNumber: "9418132222",
  autoHideDuration: 3500,
  panCharLimit: 10,
  ifscCodeCharLimit: 11,
  accountNumberCharLimit: 18,
  pragathiAppName: 'SEMINIS'
};

export const KYCRegxConstants = {
  isfcRegx: /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/,
  panRegx: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
};

export const APIResource = {
  IFSC: "/v1/kyc/ifsc/",
  validatePAN: "/v1/kyc/customers/{customerId}/pan",
  validateBank: "/v1/kyc/customers/{customerId}/bank-account",
  customerDetails: "/v1/kyc/customers/{customerId}",
  submitKYC: "/v1/kyc/customers/{customerId}",
  uploadCancelledCheque: "/v1/kyc/customers/{customerId}/documents/upload-url",
};

export const ClientList ={
  'SEMINIS' : '',
  'BRP' : ''
}
